// TODO: do more research on headless disclosure for JS, should support keyboard navigation

const expandClasses = ['tw-opacity-100', 'tw-max-h-[300px]']
const collapseClasses = ['tw-opacity-0', 'tw-max-h-0']

/**
 * Add JavaScript functionality to an accordion component
 * @param {string} name Name of the accordion. Defined by adding `data-js="name"` to the accordion wrapper element
 * @param {Object} [options] Define subcomponent selectors of the accordion, including section, expander, and content
 * @param {string} [options.sectionSelector] Selector for the accordion section element
 * @param {string} [options.expanderSelector] Selector for the accordion expander element
 * @param {string} [options.contentSelector] Selector for the accordion content element
 * @constructor
 */
export const Accordion = (
  name = 'accordion',
  options = {
    sectionSelector: '[data-js*="section"]',
    expanderSelector: '[data-js*="expander"]',
    contentSelector: '[data-js*="content"]',
  },
) => {
  const wrapperSelector = `[data-js*="${name}"]`
  const accordionElement = document.querySelector(wrapperSelector)
  const sectionElements = Array.from(
    accordionElement.querySelectorAll(options.sectionSelector ?? "[data-js*='section']"),
  )
  const expanderElements = Array.from(
    accordionElement.querySelectorAll(options.expanderSelector ?? "[data-js*='expander']"),
  )
  const contentElements = Array.from(
    accordionElement.querySelectorAll(options.contentSelector ?? "[data-js*='content']"),
  )

  const faqElements = []

  for (let i = 0; i < sectionElements.length; i++) {
    const section = sectionElements[i]
    const expander = expanderElements[i]
    const content = contentElements[i]
    faqElements.push({ section, expander, content })
  }

  faqElements.forEach(({ section, expander, content }) => {
    const toggleAccordion = () => {
      const isExpanded = section['aria-expanded'] === true
      if (isExpanded) {
        section['aria-expanded'] = false
        expander.src = '/assets/img/reskin/plus.svg'
        content.classList.add(...collapseClasses)
        content.classList.remove(...expandClasses)
        return
      }
      section['aria-expanded'] = true
      expander.src = '/assets/img/reskin/minus.svg'
      content.classList.add(...expandClasses)
      content.classList.remove(...collapseClasses)
    }

    // Set default state for each accordion
    content.classList.add('tw-transition-all', 'tw-duration-300', 'tw-overflow-hidden')
    content.classList.add(...collapseClasses)

    section.addEventListener('click', () => {
      toggleAccordion()
    })
  })
}
